import DateInput from 'elements/input/DateInput'
import { DATE_CHOICES as BASE_DATE_CHOICES } from 'elements/filtering/types'
import lodash from 'lodash'
import { styled } from 'opensolar-ui'
import { FC, useEffect, useMemo } from 'react'
import { SelectInput } from 'react-admin'
import { useForm, useFormState } from 'react-final-form'
import { dateParserYYYYMMDD } from 'util/misc'

const EXTRA_DATE_CHOICES = [
  { id: 2, name: 'Is on' },
  { id: 3, name: 'Is before' },
  { id: 4, name: 'Is after' },
]

const DATE_CHOICES = [...BASE_DATE_CHOICES, ...EXTRA_DATE_CHOICES]

export type DateFilterFieldId = 'dateSold' | 'dateCreated' | 'dateInstalled' | 'dateModified'

interface PropTypes {
  source: string
  fieldId: DateFilterFieldId
}

const sourceString = {
  dateSold: 'sold_on',
  dateCreated: 'created',
  dateInstalled: 'installation',
  dateModified: 'modified',
}

const sourceSuffix = ['gte', 'lte', 'eq', 'lt', 'gt']

const getFilterKey = (source: DateFilterFieldId, conditional: number): string => {
  const sourceStr = sourceString[source]
  const suffix = sourceSuffix[conditional]
  return `${sourceStr}_date_${suffix}`
}

const StyledDateInput = styled(DateInput)({
  width: 180,
})

const DateFilter: FC<PropTypes> = ({ source, fieldId }) => {
  const form = useForm()
  const formValues = useFormState().values
  const value = useMemo(() => lodash.get(formValues, `${source}.fields`), [formValues, source])
  useEffect(() => {
    let newValue = {}
    if (value?.conditional && value?.date) {
      newValue[getFilterKey(fieldId, value.conditional)] = value.date
    }
    form.change(`${source}.value`, newValue)
  }, [value, source, fieldId, form])
  return (
    <>
      <SelectInput
        choices={DATE_CHOICES}
        label={false}
        source={`${source}.fields.conditional`}
        variant="outlined"
        margin={'none'}
        style={{ minWidth: '100px' }}
      />
      <StyledDateInput
        inputVariant={'outlined'}
        source={`${source}.fields.date`}
        label={false}
        options={{ color: 'secondary' }}
        parse={dateParserYYYYMMDD}
      />
    </>
  )
}

export default DateFilter

